import { Box, Divider, Text } from "@chakra-ui/react";
import { CreditsBox } from "./CreditsBox";
import ContactBox from "./ContactBox";
import Font, { Spacing } from "../Utils/Calligraphy";
import { Strings } from "../Utils/Strings";

export const FooterBox = () => {
  return (
    <Box
      flex={1}
      w="100%"
      display="flex"
      alignItems="center"
      flexDirection="column"
      paddingX={Spacing.Padded}
    >
      <Box h={"1vh"} />
      <CreditsBox />
      <ContactBox />
      <Divider />
      <Box h={"1vh"} />
      <Text fontFamily={Font.Light} textAlign={Spacing.TextAlignCenter}>
        {Strings.CopyrightHorik}
      </Text>
      <Box h={"1vh"} />
    </Box>
  );
};
